import * as routerTypes from "./routerTypes";

export const routerLinks = (type) => {
  let x = routerLinksArray.find((element, index) => {
    if (element.type === type) {
      return true;
    }
  });

  return x.path;
};

const routerLinksArray = [
  {
    type: routerTypes.HOME,
    path: "/",
  },
  {
    type: routerTypes.PERSON_ADD,
    path: "/person/add",
  },
  {
    type: routerTypes.PERSON_ADD_ADMIN,
    path: "/person/admin/add",
  },
  {
    type: routerTypes.PERSON_LIST,
    path: "/person/list",
  },
  {
    type: routerTypes.PERSON_EDIT,
    path: "/person/edit/:id",
  },
  {
    type: routerTypes.PERSON_EDIT_ADMIN,
    path: "/person/admin/edit/:id",
  },
  {
    type: routerTypes.CAR_CONTRACT_ADD,
    path: "/car-contract/add",
  },
  {
    type: routerTypes.CAR_CONTRACT_LIST,
    path: "/car-contract/list",
  },
  {
    type: routerTypes.CAR_CONTRACT_LIST_USER,
    path: "/car-contract/user/:id/:name",
  },
  {
    type: routerTypes.CAR_CONTRACT_EDIT,
    path: "/car-contract/edit/:id",
  },
  {
    type: routerTypes.DEBIT_CREDIT_ADD,
    path: "/debit-credit/add",
  },
  {
    type: routerTypes.DEBIT_CREDIT_LIST,
    path: "/debit-credit/list",
  },
  {
    type: routerTypes.DEBIT_CREDIT_LIST_USER,
    path: "/debit-credit/user/:id/:name",
  },
  {
    type: routerTypes.DEBIT_CREDIT_EDIT,
    path: "/debit-credit/edit/:id",
  },
  {
    type: routerTypes.BANK_ACCOUNT_ADD,
    path: "/bank-account/add",
  },
  {
    type: routerTypes.BANK_ACCOUNT_LIST,
    path: "/bank-account/list",
  },
  {
    type: routerTypes.BANK_ACCOUNT_LIST_USER,
    path: "/bank-account/user/:id/:name",
  },
  {
    type: routerTypes.BANK_ACCOUNT_EDIT,
    path: "/bank-account/edit/:id",
  },
  {
    type: routerTypes.LEGAL_ENTITY_ADD,
    path: "/legal-entity/add",
  },
  {
    type: routerTypes.LEGAL_ENTITY_LIST,
    path: "/legal-entity/list",
  },
  {
    type: routerTypes.LEGAL_ENTITY_LIST_USER,
    path: "/legal-entity/user/:id/:name",
  },
  {
    type: routerTypes.LEGAL_ENTITY_EDIT,
    path: "/legal-entity/edit/:id",
  },
  {
    type: routerTypes.CHEQUE_CONTRACT_ADD,
    path: "/cheque-contract/add",
  },
  {
    type: routerTypes.CHEQUE_CONTRACT_EDIT,
    path: "/cheque-contract/edit/:id",
  },
  {
    type: routerTypes.CHEQUE_CONTRACT_LIST,
    path: "/cheque-contract/list",
  },
  {
    type: routerTypes.CHEQUE_CONTRACT_LIST_USER,
    path: "/cheque-contract/user/:id/:name",
  },
  {
    type: routerTypes.CHEQUE_ADD,
    path: "/cheque/add",
  },
  {
    type: routerTypes.CHEQUE_LIST,
    path: "/cheque/list/:type",
  },
  {
    type: routerTypes.CHEQUE_LIST_USER,
    path: "/cheque/user/:id/:name",
  },
  {
    type: routerTypes.CHEQUE_LIST_HISTORY,
    path: "/cheque/history/:id",
  },
  {
    type: routerTypes.CHEQUE_LIST_CAR_CONTRACT,
    path: "/cheque/car-contract/:id",
  },
  {
    type: routerTypes.CHEQUE_EDIT,
    path: "/cheque/edit/:id",
  },
  {
    type: routerTypes.PROFILE,
    path: "/profile",
  },

  {
    type: routerTypes.CONTACT,
    path: "/contact",
  },
  {
    type: routerTypes.REGISTER,
    path: "/register",
  },
  {
    type: routerTypes.REGISTERCONFIRM,
    path: "/register/confirm/:cellphone",
  },
  {
    type: routerTypes.LOGOUT,
    path: "/logout",
  },
  {
    type: routerTypes.FORGETPASSWORD,
    path: "/ForgetPassword",
  },
  {
    type: routerTypes.LOGIN,
    path: "/login",
  },
  {
    type: routerTypes.SETTING_LIST,
    path: "/settings/list",
  },
  {
    type: routerTypes.SETTING_EDIT,
    path: "/settings/edit/:id",
  },
  {
    type: routerTypes.PERSON_LIST_ADMIN,
    path: "/person/admin/list",
  },
];
